import { Page } from '@/core/architecture'

import { ConsoleEventEditTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleEventEdit Page
 * Implemented as a practical sample.
 */
export const ConsoleEventEdit: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleEventEditTemplate state={state} {...actions} />
}
